module.exports = __webpack_public_path__ + "media/images/front/not-logged-in-lp-renew/img_webinar_02-734167e450005d5c29c18b41f22d9c4c.png";